{
  "findAndReplace": "Find & Replace",
  "goToLine": "Go To Line",
  "undo": "Undo",
  "redo": "Redo",
  "save": "Save",
  "position": "Position:",
  "ln": "Ln",
  "ch": "Ch",
  "findNext": "Find Next",
  "replace": "Replace",
  "replaceAll": "Replace All",
  "matchCase": "Match Case",
  "regularExpression": "Regular Expression",
  "wordWrap": "Word Wrap",
  "highlightSyntax": "Highlight Syntax",
  "appName": "Attribute Management Studio",
  "change-password": "Change Password",
  "profile": "Profile",
  "created": "Created",
  "from": "From",
  "updated": "Updated",
  "any": "Any",
  "datePlaceholder": "Select a Date",
  "back": "Back",
  "next": "Next",
  "export": "Export",
  "import": "Import",
  "deploy": "Deploy",
  "pleaseChoose": "Please Choose...",
  "searchFieldEmpty": "Search field empty",
  "notFound": " not found",
  "occurrencesReplaced": " occurrences replaced",
  "dataSources": "Data Sources",
  "segments": "Segments",
  "arguments": "Arguments",
  "ignorePendingEditsAndSwitchDatasource": "OK",
  "unsavedChanges": "Are you sure?",
  "areYouSureDatasource": "You have modified the code. Are you sure you would like to change the data source and lose your code changes?"
}
